@if (moveCopyForm) {
  <form [formGroup]="moveCopyForm">
    <div
      class="action-buttons-group"
      sui-radio-group
      [ngModel]="globalAction"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onGlobalActionChange($event)"
    >
      <sui-radio value="copy">{{ "btn.copy" | translate }}</sui-radio>
      <sui-radio value="move">{{ "btn.move" | translate }}</sui-radio>
    </div>
    <!-- Table container with sticky header -->
    <div class="table-container">
      <table class="table table-bordered table-hover">
        <thead class="table-header-sticky">
          <tr>
            <th scope="col" class="col-widget-title">
              {{
                "widget-actions.move-copy-dialog.selected-widgets" | translate
              }}
            </th>
            <th scope="col" class="col-action">
              {{ "widget-actions.move-copy-dialog.action" | translate }}
            </th>
            <th scope="col" class="col-destination">
              <div class="col-destination-content">
                <div class="label">
                  {{ "widget-actions.move-copy-dialog.new-page" | translate }}
                </div>
                <div class="bulk-page-selector">
                  <sui-select
                    formControlName="bulkPageId"
                    [placeholder]="
                      'widget-actions.move-copy-dialog.select-page' | translate
                    "
                    [title]="
                      'widget-actions.move-copy-dialog.bulk-page-tooltip'
                        | translate
                    "
                  >
                    @for (page of availablePages; track page) {
                      <sui-select-option
                        [value]="page.id.toString()"
                        [label]="page.page_order + '. ' + page.name"
                        >{{ page.page_order }}.
                        {{ page.name }}</sui-select-option
                      >
                    }
                  </sui-select>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody formArrayName="widgets">
          @for (
            widgetControl of widgetFormArray.controls;
            track widgetControl;
            let i = $index
          ) {
            <tr [formGroupName]="i">
              <!-- Widget Title Column -->
              <td class="widget-title-cell">
                <div class="widget-title-content">
                  <fa-icon
                    [icon]="['fas', 'chart-bar']"
                    class="widget-icon me-2"
                  ></fa-icon>
                  <span class="widget-title">{{
                    widgetControl.get("title")?.value
                  }}</span>
                </div>
              </td>
              <!-- Action Column -->
              <td class="action-cell">
                <div class="action-display">
                  <span class="action-badge">
                    {{
                      getActionDisplayText(
                        $safeNavigationMigration(
                          widgetControl.get("action")?.value
                        )
                      )
                    }}
                  </span>
                </div>
              </td>
              <!-- Destination Page Column -->
              <td class="destination-cell">
                <sui-select
                  formControlName="target_page_id"
                  [placeholder]="
                    'widget-actions.move-copy-dialog.select-page' | translate
                  "
                >
                  @for (page of availablePages; track page) {
                    <sui-select-option
                      [value]="page.id.toString()"
                      [label]="page.page_order + '. ' + page.name"
                      >{{ page.page_order }}. {{ page.name }}</sui-select-option
                    >
                  }
                </sui-select>
                @if (
                  widgetControl.get("target_page_id")?.invalid &&
                  widgetControl.get("target_page_id")?.touched
                ) {
                  <div class="invalid-feedback">
                    {{
                      "widget-actions.move-copy-dialog.page-required"
                        | translate
                    }}
                  </div>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <!-- No pages message -->
    @if (availablePages.length === 0) {
      <div class="no-pages-message">
        <fa-icon [icon]="['fas', 'exclamation-triangle']"></fa-icon>
        {{ "widget-actions.move-copy-dialog.no-pages-available" | translate }}
      </div>
    }
  </form>
}
